/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductClaimAttachment
 */
export interface ProductClaimAttachment {
    /**
     * 
     * @type {string}
     * @memberof ProductClaimAttachment
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProductClaimAttachment
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductClaimAttachment
     */
    contentType: string;
}

/**
 * Check if a given object implements the ProductClaimAttachment interface.
 */
export function instanceOfProductClaimAttachment(value: object): value is ProductClaimAttachment {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('contentType' in value) || value['contentType'] === undefined) return false;
    return true;
}

export function ProductClaimAttachmentFromJSON(json: any): ProductClaimAttachment {
    return ProductClaimAttachmentFromJSONTyped(json, false);
}

export function ProductClaimAttachmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductClaimAttachment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'contentType': json['content_type'],
    };
}

export function ProductClaimAttachmentToJSON(json: any): ProductClaimAttachment {
    return ProductClaimAttachmentToJSONTyped(json, false);
}

export function ProductClaimAttachmentToJSONTyped(value?: ProductClaimAttachment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'content_type': value['contentType'],
    };
}

